import { app } from "../../firebase-config.js";
import { getAuth, GoogleAuthProvider, reauthenticateWithPopup, deleteUser } from "firebase/auth";

const auth = getAuth(app);

export const DeleteAccountModal = {
    show: () => {
        const overlay = document.createElement('div');
        overlay.className = "fixed inset-0 bg-black/80 z-[9999] flex items-center justify-center fade-in p-4 backdrop-blur-sm";
        overlay.style.zIndex = "9999";

        const modal = document.createElement('div');
        modal.className = "bg-zinc-900 border border-red-900/50 w-full max-w-md rounded-2xl shadow-2xl overflow-hidden animate-scale-in relative isolate";

        modal.innerHTML = `
            <!-- Cosmic Background Effect -->
            <div class="absolute inset-0 bg-gradient-to-br from-black via-zinc-900 to-red-900/20 -z-10"></div>
            
            <div class="p-8 text-center">
                <div class="w-20 h-20 bg-zinc-800 rounded-full flex items-center justify-center mx-auto mb-6 shadow-inner ring-4 ring-zinc-800 relative">
                    <span class="material-symbols-outlined text-4xl text-gray-400">rocket_launch</span>
                    <span class="absolute -bottom-1 -right-1 text-2xl">🌍</span>
                </div>

                <h2 class="text-2xl font-bold text-white mb-2 tracking-tight">정말 현실 세계로<br>복귀하시겠어요?</h2>
                
                <div class="bg-red-900/10 border border-red-900/30 rounded-xl p-4 my-6 text-left">
                    <p class="text-red-200 text-sm leading-relaxed flex items-start gap-3">
                        <span class="material-symbols-outlined text-red-500 shrink-0">warning</span>
                        <span>지금 떠나시면 보관함의 작품들과 활동 기록이 <b class="text-white">블랙홀 속으로 영원히 사라집니다.</b> 🌌<br>복구할 수 없습니다.</span>
                    </p>
                </div>

                <p class="text-zinc-500 text-sm mb-8">차원 서비스 [SSULWHA]와의 연결을 끊으시겠습니까?</p>

                <div class="flex flex-col gap-3">
                    <button id="btn-stay" class="w-full py-3.5 bg-indigo-600 hover:bg-indigo-500 text-white font-bold rounded-xl shadow-lg shadow-indigo-900/30 transition-all active:scale-[0.98] text-base group">
                        아니요! 더 여행할래요 🚀
                    </button>
                    <button id="btn-leave" class="w-full py-3.5 bg-transparent hover:bg-red-900/20 text-zinc-500 hover:text-red-400 font-bold rounded-xl border border-zinc-800 hover:border-red-900/50 transition-colors text-sm">
                        네, 지구로 돌아갑니다
                    </button>
                </div>
            </div>
        `;

        overlay.appendChild(modal);
        document.body.appendChild(overlay);

        // Actions
        const close = () => {
            modal.classList.add('scale-95', 'opacity-0');
            setTimeout(() => overlay.remove(), 200);
        };

        // 1. Stay (Cancel)
        modal.querySelector('#btn-stay').onclick = close;
        overlay.onclick = (e) => { if (e.target === overlay) close(); };

        // 2. Leave (Delete Logic)
        const btnLeave = modal.querySelector('#btn-leave');
        btnLeave.onclick = async () => {
            if (!confirm("정말 탈퇴하시겠습니까? 돌이킬 수 없습니다.")) return;

            btnLeave.disabled = true;
            btnLeave.innerHTML = `<span class="loader-spin inline-block w-4 h-4 border-2 border-red-500 border-t-transparent rounded-full animate-spin"></span> 보안 인증 중...`;

            try {
                const user = auth.currentUser;
                const provider = new GoogleAuthProvider();

                // IMPORTANT: Re-authenticate first
                await reauthenticateWithPopup(user, provider);

                // If successful, proceed with delete
                btnLeave.innerHTML = "계정 삭제 중...";
                await deleteUser(user);

                // Success
                alert("지구로 무사히 귀환하셨습니다. 👋\n이용해 주셔서 감사합니다.");
                window.location.reload(); // Hard Reset

            } catch (error) {
                console.error("Delete Account Error:", error);

                if (error.code === 'auth/popup-closed-by-user') {
                    btnLeave.innerHTML = "네, 지구로 돌아갑니다";
                    window.Modal.alert("인증이 취소되었습니다.");
                } else {
                    btnLeave.innerHTML = "네, 지구로 돌아갑니다";
                    window.Modal.alert("오류가 발생했습니다: " + error.message);
                }
                btnLeave.disabled = false;
            }
        };
    }
};
